import { render, staticRenderFns } from "./RectChart.vue?vue&type=template&id=e7f1029a"
import script from "./RectChart.vue?vue&type=script&lang=js"
export * from "./RectChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports